import { Box, Button, Text, VStack } from '@chakra-ui/react';
import { usePageTitle } from '../hooks/usePageTitle';
import { useNavigate } from 'react-router-dom';
import { HiArrowLeft } from 'react-icons/hi2';

export function NotFound() {
  usePageTitle('Page Not Found');
  const navigate = useNavigate();

  return (
    <Box
      display="flex"
      w="100%"
      justifyContent="center"
      alignItems="center"
      minH="100vh"
      bg="surface.primary"
    >
      <VStack gap={4}>
        <Text as="h1" fontSize="5xl" fontWeight={700} color="text.secondary">
          404
        </Text>
        <Text fontSize="lg" color="text.secondary">
          The page you're looking for doesn't exist.
        </Text>
        <Button
          variant="outline"
          onClick={() => navigate('/')}
          mt={4}
         data-e2e="back-to-dashboard-button">
          <HiArrowLeft />
          Back to Dashboard
        </Button>
      </VStack>
    </Box>
  );
}
